import { createAsyncSlice } from 'store/createAsyncSlice';
import { putResetOrderByIDAsync } from '../../../ui-toolkit/orders/methods/OrderApiRestService';

export const { slice: resetOrderSlice, asyncAction: putResetOrderByIDAsyncAction } = createAsyncSlice(
  'resetOrderSlice',
  putResetOrderByIDAsync
);
